import React, { Component } from "react";
import { connect } from "react-redux";
import { message, Select, Row, Col } from "antd";
import { SwapOutlined, EnvironmentOutlined } from "@ant-design/icons";
import { FormItem, SelectItem, TextAreaItem, DynamicCardForm } from "../../../../../Components/Items";
import SelectClientesItem from "../../../../../Components/SelectClientesItem";
import ModalFormCMMS from "../../componentes/ModalFormCMMS";
import CampoSugerenciasCMMS from "../../componentes/CampoSugerenciasCMMS";
import { cmmsPost, cargarSucursales } from "../../cmmsComun";

const { Option } = Select;

// Mueve un activo a otro cliente / sucursal / ubicacion / area y deja historial.
// Dejar el cliente vacio = el activo queda "Sin cliente".
class ModalTransferirActivo extends Component {
    formRef = React.createRef();
    state = { loading: false, sucursales: [], clienteId: null, direccionId: null, ubicacion: "" };

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) {
            this.formRef.current?.resetFields();
            this.setState({ sucursales: [], clienteId: null, direccionId: null, ubicacion: "" });
        }
    }

    onChangeCliente = async (clienteId) => {
        this.formRef.current?.setFieldsValue({ direccionId: undefined, ubicacion: undefined, area: undefined });
        this.setState({ clienteId: clienteId || null, direccionId: null, ubicacion: "", sucursales: [] });
        if (clienteId) this.setState({ sucursales: await cargarSucursales(this.props, clienteId) });
    };

    onValuesChange = (cambios) => {
        if ("direccionId" in cambios) this.setState({ direccionId: cambios.direccionId || null });
        if ("ubicacion" in cambios) this.setState({ ubicacion: cambios.ubicacion || "" });
    };

    onFinish = async (values) => {
        this.setState({ loading: true });
        try {
            const res = await cmmsPost(this.props, "transferirActivoCMMS", {
                id: this.props.activoId,
                clienteId: values.clienteId || null,
                direccionId: values.direccionId || null,
                ubicacion: values.ubicacion || "",
                area: values.area || "",
                motivo: values.motivo || "",
            });
            if (res.data.success === 2) {
                message.success("Activo transferido");
                this.props.onClose(true);
            } else {
                message.error(res.data.message || "No se pudo transferir el activo");
            }
        } catch (error) {
            console.log(error);
            message.error("No se pudo transferir el activo");
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const sinCliente = !this.state.clienteId;
        return (
            <ModalFormCMMS
                titulo="Transferir activo"
                subtitulo="Cambie al equipo de cliente o de lugar. Queda registrado en su historial."
                icono={<SwapOutlined style={{ fontSize: 20, color: "#2fb8d6" }} />}
                visible={this.props.visible}
                loading={this.state.loading}
                onCancel={() => this.props.onClose(false)}
                formRef={this.formRef}
                name="transferirActivoCMMS"
                onFinish={this.onFinish}
                onValuesChange={this.onValuesChange}
                textoGuardar="Transferir"
                width={680}
            >
                <DynamicCardForm title="Destino" xs={24}>
                    <div className="cmms-banda">
                        <EnvironmentOutlined style={{ color: "#2fb8d6", marginTop: 2 }} />
                        <div>
                            <div className="cmms-banda-secundaria" style={{ marginTop: 0 }}>Ubicación actual</div>
                            <b>{this.props.ubicacionActual || "Sin cliente"}</b>
                        </div>
                    </div>
                    <FormItem label="Nuevo cliente" name="clienteId" tooltip="Déjelo vacío para dejar el equipo sin cliente. Si cambia de cliente, el equipo sale del contrato que tenga.">
                        <SelectClientesItem empresaId={this.props.empresaId} headersToken={this.props.headersToken} width="100%" allowClear placeholder="Buscar cliente (vacío = sin cliente)" onChange={this.onChangeCliente} />
                    </FormItem>
                    <Row gutter={12}>
                        <Col xs={24} md={8} className={sinCliente ? "cmms-campo-espera" : ""}>
                            <FormItem label="Sucursal" name="direccionId">
                                <SelectItem placeholder={sinCliente ? "Elija un cliente" : "Sucursal"} allowClear disabled={sinCliente}>
                                    {this.state.sucursales.map((s) => (
                                        <Option key={s._id} value={s._id}>
                                            {s.nombre}
                                        </Option>
                                    ))}
                                </SelectItem>
                            </FormItem>
                        </Col>
                        <Col xs={24} md={8} className={sinCliente ? "cmms-campo-espera" : ""}>
                            <FormItem label="Ubicación" name="ubicacion" max={80}>
                                <CampoSugerenciasCMMS
                                    empresaId={this.props.empresaId}
                                    headersToken={this.props.headersToken}
                                    placeholder={sinCliente ? "Elija un cliente" : "General"}
                                    disabled={sinCliente}
                                    params={{ campo: "ubicacion", clienteId: this.state.clienteId, direccionId: this.state.direccionId }}
                                />
                            </FormItem>
                        </Col>
                        <Col xs={24} md={8} className={sinCliente ? "cmms-campo-espera" : ""}>
                            <FormItem label="Área" name="area" max={80}>
                                <CampoSugerenciasCMMS
                                    empresaId={this.props.empresaId}
                                    headersToken={this.props.headersToken}
                                    placeholder={sinCliente ? "Elija un cliente" : "General"}
                                    disabled={sinCliente}
                                    params={{ campo: "area", clienteId: this.state.clienteId, ubicacion: this.state.ubicacion }}
                                />
                            </FormItem>
                        </Col>
                    </Row>
                    <FormItem label="Motivo" name="motivo" tooltip="Por qué se mueve el equipo (préstamo, cambio de área, devolución...). Queda en el historial.">
                        <TextAreaItem rows={2} placeholder="Motivo de la transferencia" />
                    </FormItem>
                </DynamicCardForm>
            </ModalFormCMMS>
        );
    }
}

const mapStateToProps = (state) => ({
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalTransferirActivo);
